import { render, staticRenderFns } from "./biDetail.vue?vue&type=template&id=6dcdd496&scoped=true&"
import script from "./biDetail.vue?vue&type=script&lang=js&"
export * from "./biDetail.vue?vue&type=script&lang=js&"
import style0 from "./biDetail.vue?vue&type=style&index=0&id=6dcdd496&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcdd496",
  null
  
)

export default component.exports